import types from './types';

const INITIAL_STATE = {
  isUploading: false,
  isFetching: false,
  isFetchingAllFilesByTags: false,
  isDownloading: false,
  isDownloadingFromBlob: false,

  result: [],
  files: []
};

const authFilesReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.UPLOAD_AUTH_FILES_REQUEST:
      return {
        ...state,
        result: [],
        isUploading: true,
      };

    case types.UPLOAD_AUTH_FILES_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isUploading: false,
      };

    case types.UPLOAD_AUTH_FILES_FAILURE:
      return {
        ...state,
        result: [],
        isUploading: false,
      };

    case types.GET_SUBMITTED_FILE_NAMES_REQUEST:
      return {
        ...state,
        result: [],
        isFetching: true,
      };

    case types.GET_SUBMITTED_FILE_NAMES_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetching: false,
      };

    case types.GET_SUBMITTED_FILE_NAMES_FAILURE:
      return {
        ...state,
        result: [],
        isFetching: false,
      };

    case types.GET_ALL_FILES_BY_TAGS_REQUEST:
      return {
        ...state,
        files: [],
        isFetchingAllFilesByTags: true,
      };

    case types.GET_ALL_FILES_BY_TAGS_SUCCESS:
      return {
        ...state,
        files: action.payload,
        isFetchingAllFilesByTags: false,
      };

    case types.GET_ALL_FILES_BY_TAGS_FAILURE:
      return {
        ...state,
        files: [],
        isFetchingAllFilesByTags: false,
      };

    case types.DOWNLOAD_AUTH_FILE_REQUEST:
      return {
        ...state,
        isDownloading: true,
      };

    case types.DOWNLOAD_AUTH_FILE_SUCCESS:
      return {
        ...state,
        isDownloading: false,
      };

    case types.DOWNLOAD_AUTH_FILE_FAILURE:
      return {
        ...state,
        isDownloading: false,
      };

    case types.DOWNLOAD_FILE_BLOB_REQUEST:
      return {
        ...state,
        isDownloadingFromBlob: true,
      };

    case types.DOWNLOAD_FILE_BLOB_SUCCESS:
      return {
        ...state,
        isDownloadingFromBlob: false,
      };

    case types.DOWNLOAD_FILE_BLOB_FAILURE:
      return {
        ...state,
        isDownloadingFromBlob: false,
      };

    default:
      return state;
  }
};

export default authFilesReducer;
